function leg(legData) {
    const legPrototype = {};

    legPrototype.getArrivalDate = function() {
        return Odigeo._.get(legData, `${this._legPath}.arrivalDate`, 0);
    };

    legPrototype.getDepartureDate = function() {
        return Odigeo._.get(legData, `${this._legPath}.departureDate`, 0);
    };

    legPrototype.getCityIata = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.cityIataCode`, '');
    };

    legPrototype.getDestinationAirportIata = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.iataCode`, '');
    };

    legPrototype.getOriginAirpotIata = function() {
        return Odigeo._.get(legData, `${this._originPath}.iataCode`, '');
    };

    legPrototype.getOriginCountryCode = function() {
        return Odigeo._.get(legData, `${this._originPath}.countryCode`, '');
    };

    legPrototype.getDestinationCountryCode = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.countryCode`, '');
    };

    legPrototype.getOriginCountryName = function() {
        return Odigeo._.get(legData, `${this._originPath}.countryName`, '');
    };

    legPrototype.getDestinationCountryName = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.countryName`, '');
    };

    legPrototype.getOriginType = function() {
        return Odigeo._.get(legData, `${this._originPath}.type`, '').toUpperCase();
    };

    legPrototype.getDestinationType = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.type`, '').toUpperCase();
    };

    legPrototype.getOriginCityName = function() {
        return Odigeo._.get(legData, `${this._originPath}.cityName`, '');
    };

    legPrototype.getCityName = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.cityName`, '');
    };

    legPrototype.getOriginName = function() {
        return Odigeo._.get(legData, `${this._originPath}.name`, '');
    };

    legPrototype.getDestinationName = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.name`, '');
    };

    legPrototype.getOriginGeoNodeId = function() {
        return Odigeo._.get(legData, `${this._originPath}.geoNodeId`, '');
    };

    legPrototype.getGeoNodeId = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.geoNodeId`, '');
    };

    legPrototype.getCabinClass = function() {
        return Odigeo._.get(legData, `${this._legPath}.cabinClass`, '');
    };

    legPrototype.getFlightNumber = function() {
        const carrierCode = Odigeo._.get(legData, `${this._legPath}.carrier.code`, '');
        const flightId = Odigeo._.get(legData, `${this._legPath}.id`, 0);

        return `${carrierCode}${flightId}`;
    };

    return legPrototype;
}

module.exports = leg;
